import React, {useState, useEffect} from 'react'
import { Link, useParams, useNavigate } from "react-router-dom";
import { faUser, faEnvelope, faPhone, faLock, faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { isEmailUtil, isEntryLengthUtil } from '../utils/validationUtils';
import GoogleLoginButton from './GoogleLoginButton';
import FacebookLoginButton from './FacebookLoginButton';
import aMediator from './aMediator';

function Registration() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [frmMsg, setFrmMsg] = useState("");
    const [posting, setPosting] = useState(false);
    const [modal, setModal] = useState(false);

    let { entry } = useParams();
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    const showModal = ()=>{
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }
 
    const postForm = ()=>{

        setFrmMsg("")

        if(name == ""){
            setFrmMsg("Please enter name");
            return;
        }

        if(!isEntryLengthUtil(name, 2)){
            setFrmMsg("Please enter a valid name");
            return;
        }

        if(email == ""){
            setFrmMsg("Please enter email address");
            return;
        }

        if(!isEmailUtil(email)){
            setFrmMsg("Please enter a valid email address");
            return;
        }

        if(phone == ""){
            setFrmMsg("Please enter phone number")
            return;
        }

        if(!isEntryLengthUtil(phone, 6)){
            setFrmMsg("Please enter a valid phone number");
            return;
        }

        if(password == ""){
            setFrmMsg("Please enter password")
            return;
        }

        if(confirm == ""){
            setFrmMsg("Please enter confirm password")
            return;
        }

        if(password != confirm){
            setFrmMsg("Password and confirm password did not match")
            return;
        }

        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('password', password);
        formData.append('interest', entry);

        setPosting(true);

        axios({
            method: "post",
            url: API_URL + "user/save_user",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            const obj = response.data;
            if(obj.Success){
                localStorage.setItem("session", obj.Data);
                aMediator(entry, code);
            }else if(obj.Status == "duplicate"){
                setFrmMsg(obj.Message);
                setPosting(false);
            }else{
                setFrmMsg(obj.Message);
                setPosting(false);
            }
        })
        .catch(function (response) {
              setPosting(false)
        });
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        form: {
            background: '#fff',
        },
        formHeader: {
            marginBottom:30
        },
        formTitle:{
            fontSize:20
        },
        formGoogleBtn:{
            marginBottom: 20
        },
        formFacebookBtn:{
            marginBottom: 20
        },
        formEmailBtn:{
            wrap:{
                marginBottom: 30
            },
            btn: {
                backgroundColor: '#fff',
                color: '#3c4043',
                width: '100%',
                padding: '7px',
                border: 'none',
                borderRadius: '5px',
                fontSize: '15px',
                border: '1px solid #dadce0',
                cursor: 'pointer',
                position: 'relative'
            },
            icon:{
                color: '#00a924',
                fontSize: 18,
                position: 'absolute',
                top: 11,
                left: 13
            }
        },
        formLabel: {
            fontSize:14,
            fontWeight: '600'
        },
        FormBtn: {
            width: '100%',
            marginTop:20,
            marginBottom:20,
            fontWeight: 500 
        },
        loginLink: {
            fontSize:16,
            fontWeight: 500,
            textDecoration: 'none' 
        },
        forgotPwd: {
            textAlign: 'right'
        },
        frmMsg: {
            color: '#990000',
            fontSize: 16,
        }
    }
    
    return (
        <div style={styles.page}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-3'></div>
                    <div className='col-md-6'>
                        <div style = {styles.form}>

                            <div style={styles.formHeader}>
                                <h2 style={styles.formTitle}>SIGN UP</h2>
                            </div>

                            <div style={styles.formGoogleBtn}>
                                <GoogleLoginButton label={"Sign up with Google"} entry={entry} code={code} />
                            </div>

                            <div style={styles.formGoogleBtn}>
                                <FacebookLoginButton label={"Sign up with Facebook"} entry={entry} code={code} />
                            </div>

                            <div style={styles.formEmailBtn.wrap}>
                                <button onClick={showModal} style={styles.formEmailBtn.btn} className='btn'>
                                    <FontAwesomeIcon icon={faEnvelope} style={styles.formEmailBtn.icon} /> Sign up with Email and Password
                                </button>
                            </div>
                            
                            <div className='form-group'>
                                <Link to={`/user/sign-in/${entry}?code=${code? code: ""}`} style={styles.loginLink}>Already have an account? Login</Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>SIGN UP</Modal.Title>
                    <button type="button" onClick={closeModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body> 

                    <div className='form-group'>
                        <label style={styles.formLabel}>Name</label>
                        <div className='input-group'>
                            <div class="input-group-prepend">
                                <span class="input-group-text"><FontAwesomeIcon icon={faUser} /></span>
                            </div>
                            <input type = "text" value={name} onChange={e => setName(e.target.value)} className='form-control' placeholder='Enter name' />
                        </div>
                    </div>
                    <div className='form-group'>
                        <label style={styles.formLabel}>Email</label>
                        <div className='input-group'>
                            <div class="input-group-prepend">
                                <span class="input-group-text"><FontAwesomeIcon icon={faEnvelope} /></span>
                            </div>
                            <input type = "text" value={email} onChange={e => setEmail(e.target.value)} className='form-control' placeholder='Enter email address' />
                        </div>
                    </div>
                    <div className='form-group'>
                        <label style={styles.formLabel}>Phone</label>
                        <div className='input-group'>
                            <div class="input-group-prepend">
                                <span class="input-group-text"><FontAwesomeIcon icon={faPhone} /></span>
                            </div>
                            <input type = "text" value={phone} onChange={e => setPhone(e.target.value)} className='form-control'  placeholder='Enter phone number'/>
                        </div>
                    </div>
                    <div className='form-group'>
                        <label style={styles.formLabel}>Password</label>
                        <div className='input-group'>
                            <div class="input-group-prepend">
                                <span class="input-group-text"><FontAwesomeIcon icon={faLock} /></span>
                            </div>
                            <input type = "password" value={password} onChange={e => setPassword(e.target.value)} className='form-control'  placeholder='Enter password' />
                        </div>
                    </div>
                    <div className='form-group'>
                        <label style={styles.formLabel}>Confirm Password</label>
                        <div className='input-group'>
                            <div class="input-group-prepend">
                                <span class="input-group-text"><FontAwesomeIcon icon={faLock} /></span>
                            </div>
                            <input type = "password" value={confirm} onChange={e => setConfirm(e.target.value)} className='form-control'  placeholder='Confirm password' />
                        </div>
                    </div>

                    <div style={styles.frmMsg} className='form-group'>{frmMsg}</div>
                    
                    <div className='form-group'>
                        <button onClick={postForm} style={styles.FormBtn} disabled={posting} className='btn btn-primary'>
                            {posting?'Posting ...':'SIGN UP'}
                        </button>
                    </div>

                </Modal.Body> 
            </Modal>

        </div>
    )
    
}

export default Registration